import { DatePicker } from 'antd';
import React from 'react';
import { formatDate } from 'utils';
import { FilterOptionsWrapper } from 'ui/Filter';
import dayjs from 'dayjs';

function DatePickerFilter({
  value,
  format = 'DD.MM.YYYY',
  picker = 'date',
  returnFormat = 'YYYY-MM-DD',
  getDate,
}) {
  return (
    <FilterOptionsWrapper>
      <DatePicker
        value={value ? dayjs(value, returnFormat) : null}
        picker={picker}
        style={{ width: '150px' }}
        allowClear
        format={format}
        onChange={(date) =>
          getDate(date ? formatDate(date, returnFormat) : null)
        }
      />
    </FilterOptionsWrapper>
  );
}

export { DatePickerFilter };
